/**
 * Cảnh báo TỐT NGHIỆP dùng chung (2026-07) — 1 nguồn logic cho:
 *  - banner trang chi tiết ứng viên (ngoài tab) + drawer xem nhanh
 *  - tô nền vàng row Danh sách ứng viên
 *
 * Trục DUY NHẤT = NĂM tốt nghiệp so với năm hiện tại (loại trừ lẫn nhau, không chồng điều kiện):
 *  - TN NĂM NAY (graduatedYear = năm hiện tại): thi năm nay, chưa có bằng -> phải nhập ĐIỂM THI TN,
 *    đủ 3 môn, tổng 3 môn cao nhất >= 15 (sàn tổ hợp). KHÔNG đòi số hiệu bằng.
 *  - TN NĂM TRƯỚC (graduatedYear khác năm hiện tại): đã có bằng -> phải có SỐ HIỆU BẰNG.
 *    KHÔNG đòi điểm thi TN.
 *  - Chưa có năm TN -> không cảnh báo ở đây (missingImportant lo phần thiếu "Năm tốt nghiệp").
 * (Trước đây số hiệu bằng kích theo highschoolGraduation=='graduated' -> chồng với điều kiện năm,
 *  gây 2 cảnh báo mâu thuẫn "TN năm nay" + "TN năm trước" cho cùng 1 hồ sơ.)
 */
export function gradWarningsOf(stu: any): string[] {
  const w: string[] = [];
  if (!stu) return w;
  const currYear = new Date().getFullYear();
  const gy = Number(stu.graduatedYear);
  if (!gy) return w; // chưa khai năm TN -> chưa xét cảnh báo tốt nghiệp
  if (gy === currYear) {
    // TN năm nay -> cần điểm thi TN
    const scores = Object.values(stu.graduationscore || {})
      .map(Number)
      .filter((v) => !isNaN(v) && v > 0);
    if (!scores.length) {
      w.push(`Tốt nghiệp năm ${currYear} nhưng CHƯA nhập điểm thi tốt nghiệp`);
    } else {
      const top3 = [...scores].sort((a, b) => b - a).slice(0, 3);
      const sum = Math.round(top3.reduce((t, v) => t + v, 0) * 100) / 100;
      if (top3.length < 3) w.push(`Tốt nghiệp năm ${currYear} nhưng mới nhập ${scores.length} môn điểm thi TN (cần đủ tổ hợp 3 môn)`);
      else if (sum < 15) w.push(`Điểm thi TN không đạt sàn: tổng 3 môn cao nhất ${sum} < 15`);
    }
  } else {
    // TN năm trước -> cần số hiệu bằng
    if (!stu.certificateNumber) {
      w.push(`Tốt nghiệp năm ${gy} nhưng THIẾU Số hiệu bằng tốt nghiệp`);
    }
  }
  return w;
}
